import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings'

export type DisplaySettingsParams = {
  showBreadcrumbs: SettingsParamType.Boolean
  showImage: SettingsParamType.Boolean
  showSummary: SettingsParamType.Boolean
  showDuration: SettingsParamType.Boolean
  showDate: SettingsParamType.Boolean
  showPrice: SettingsParamType.Boolean
  showCapacity: SettingsParamType.Boolean
  showAboutSection: SettingsParamType.Boolean
}

export const DEFAULT_DISPLAY_SETTINGS_PARAMS: Record<keyof DisplaySettingsParams, any> = {
  showBreadcrumbs: true,
  showImage: true,
  showSummary: true,
  showDuration: true,
  showDate: true,
  showPrice: true,
  showCapacity: true,
  showAboutSection: true,
}

export const displaySettingsParams = createSettingsParams<DisplaySettingsParams>({
  showBreadcrumbs: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showBreadcrumbs,
  },
  showImage: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showImage,
  },
  showSummary: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showSummary,
  },
  showDuration: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showDuration,
  },
  showDate: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showDate,
  },
  showPrice: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showPrice,
  },
  showCapacity: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showCapacity,
  },
  showAboutSection: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => DEFAULT_DISPLAY_SETTINGS_PARAMS.showAboutSection,
  },
})
